import React from 'react';
import { ExternalLink, Gift, Shield, Zap } from 'lucide-react';

const Offers = () => {
  const offers = [
    {
      id: 1,
      name: 'Circusbet',
      url: 'https://www.circusbet.fr/',
      bonus: "Jusqu'à 100% de réduction",
      description: 'Une expérience de paris unique avec des cotes compétitives et une interface intuitive. Profitez de promotions régulières et d\'un service client réactif.',
      icon: Gift,
      color: 'from-blue-500 to-blue-600',
      textColor: 'text-blue-600',
      bgColor: 'bg-blue-50',
    },
    {
      id: 2,
      name: 'Bwin',
      url: 'https://bwin.fr/',
      bonus: "Jusqu'à 100€ de bonus",
      description: 'Leader européen du secteur avec une réputation solide. Accès à des milliers d\'événements sportifs et des options de paris variées pour tous les budgets.',
      icon: Shield,
      color: 'from-green-500 to-green-600',
      textColor: 'text-green-600',
      bgColor: 'bg-green-50',
    },
    {
      id: 3,
      name: 'Betsson',
      url: 'https://betsson.fr',
      bonus: 'Bonus de bienvenue de 100€ + 10€ de paris gratuits',
      description: 'Plateforme moderne offrant une expérience fluide sur tous les appareils. Bonus généreux et programme de fidélité récompensant votre activité régulière.',
      icon: Zap,
      color: 'from-purple-500 to-purple-600',
      textColor: 'text-purple-600',
      bgColor: 'bg-purple-50',
    },
  ];

  return (
    <section id="offres" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Offres exclusives du moment
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Sélection rigoureuse des meilleures opportunités pour maximiser vos gains dès le premier dépôt
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {offers.map((offer, index) => {
            const Icon = offer.icon;
            return (
              <div
                key={offer.id}
                itemScope
                itemType="https://schema.org/Product"
                className={`relative bg-white rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 overflow-hidden border-2 border-gray-100 ${
                  index === 1 ? 'lg:scale-105 lg:z-10' : ''
                }`}
              >
                {/* Gradient accent */}
                <div className={`h-2 bg-gradient-to-r ${offer.color}`}></div>
                
                <div className="p-8">
                  {/* Icon and name */}
                  <div className="flex items-center justify-between mb-6">
                    <div className={`${offer.bgColor} p-4 rounded-xl`}>
                      <Icon className={offer.textColor} size={32} />
                    </div>
                    <span className={`text-sm font-semibold ${offer.textColor} px-3 py-1 rounded-full ${offer.bgColor}`}>
                      Recommandé
                    </span>
                  </div>

                  <h3 className="text-2xl font-bold text-gray-900 mb-3" itemProp="name">{offer.name}</h3>
                  
                  <div className="mb-4">
                    <p className="text-sm text-gray-500 mb-2">Bonus de bienvenue</p>
                    <p className={`text-lg font-bold ${offer.textColor}`} itemProp="offers">{offer.bonus}</p>
                  </div>

                  <p className="text-gray-600 mb-6 leading-relaxed" itemProp="description">{offer.description}</p>

                  <a
                    href={offer.url}
                    target="_blank"
                    rel="noopener noreferrer nofollow sponsored"
                    itemProp="url"
                    className={`inline-flex items-center justify-center w-full bg-gradient-to-r ${offer.color} text-white px-6 py-3 rounded-lg font-semibold hover:opacity-90 transition-opacity`}
                  >
                    Jogue no {offer.name}
                    <ExternalLink className="ml-2" size={18} />
                  </a>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-12 text-center">
          <p className="text-sm text-gray-500">
            * Offres soumises aux conditions générales de chaque opérateur. 18+ | Jeu responsable
          </p>
        </div>
      </div>
    </section>
  );
};

export default Offers;

